import { createFileRoute, redirect } from '@tanstack/react-router'

// Своей главной у контура заказчика нет: в хабе он только входит, выходит и
// меняет пароль. Всё остальное — в продуктах.
export const Route = createFileRoute('/_public/customer/')({
  beforeLoad: () => {
    throw redirect({ to: '/login', replace: true })
  },
})
